import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UploadPage.css";

const UploadPage = () => {
    const [csvData, setCsvData] = useState(null);
    const [multiCsvResults, setMultiCsvResults] = useState([]);
    const [loading, setLoading] = useState(false); // ✅ NEU: Loading-State
    const navigate = useNavigate();
  
    // Sitzungs-ID aus LocalStorage abrufen
    const sessionId = localStorage.getItem("sessionId");
  
    // 🔄 Backend-Daten abrufen
    const fetchSessionData = async () => {
      if (!sessionId) {
        console.warn("Keine Sitzung vorhanden.");
        return;
      }
  
      setLoading(true); // ✅ Lade-Animation AN
      try {
        const response = await fetch(`https://app.sijelly.com/api/session/data`, {
          method: "GET",
          headers: { "Session-ID": sessionId },
        });
  
        if (response.ok) {
          const data = await response.json();
          if (data.raw_data && data.raw_data.length > 0) {
            setCsvData(data);
            console.log("Daten aus der Sitzung geladen:", data);
          }
        } else {
          console.warn("Keine gespeicherten Daten gefunden.");
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Sitzungsdaten:", error);
      } finally {
        setLoading(false); // ✅ Lade-Animation AUS
      }
    };
  
    // 📤 Einzelne CSV hochladen
    const handleSingleCsvUpload = async (file) => {
      if (!file) {
        alert("Bitte wählen Sie eine CSV-Datei aus.");
        return;
      }
  
      if (!sessionId) {
        alert("Keine Sitzung aktiv. Bitte starten Sie eine neue Sitzung.");
        return;
      }
  
      setLoading(true); // ✅ Lade-Animation AN
      const formData = new FormData();
      formData.append("file", file);
  
      try {
        const response = await fetch("https://app.sijelly.com/api/csv/upload", {
          method: "POST",
          body: formData,
          headers: { "Session-ID": sessionId },
        });
  
        if (response.ok) {
          const data = await response.json();
          setCsvData(data);
          console.log("CSV erfolgreich hochgeladen:", data);
        } else {
          alert("Fehler beim Hochladen der CSV-Datei.");
        }
      } catch (error) {
        console.error("Fehler beim Hochladen der CSV:", error);
      } finally {
        setLoading(false); // ✅ Lade-Animation AUS
      }
    };
  
    // 📤 Mehrere CSVs hochladen
    const handleMultipleCsvUpload = async (files) => {
      if (files.length === 0) {
        alert("Bitte wählen Sie mindestens eine CSV-Datei aus.");
        return;
      }
  
      if (!sessionId) {
        alert("Keine Sitzung aktiv. Bitte starten Sie eine neue Sitzung.");
        return;
      }
  
      setLoading(true); // ✅ Lade-Animation AN
      const results = [];
      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
  
        try {
          const response = await fetch("https://app.sijelly.com/api/csv/upload", {
            method: "POST",
            body: formData,
            headers: { "Session-ID": sessionId },
          });
  
          if (response.ok) {
            const data = await response.json();
            results.push({
              accountNumber: data.konto || "Keine Kontonummer gefunden",
              totalRows: data.total_rows || 0,
              oldestDate: data.oldest_date || "N/A",
              newestDate: data.newest_date || "N/A",
            });
          } else {
            console.error("Fehler beim Hochladen:", file.name);
            results.push({ accountNumber: "Fehler", totalRows: 0, oldestDate: "N/A", newestDate: "N/A" });
          }
        } catch (error) {
          console.error(`Fehler beim Hochladen ${file.name}:`, error);
          results.push({ accountNumber: "Fehler", totalRows: 0, oldestDate: "N/A", newestDate: "N/A" });
        }
      }
  
      setMultiCsvResults(results);
      setLoading(false); // ✅ Lade-Animation AUS
    };



  useEffect(() => {
    fetchSessionData(); // Prüft nur, ob Daten vorhanden sind, ohne automatisch eine Sitzung zu erstellen
  }, []);

  return (
    <div className="upload-page">
      {loading && ( // ✅ NEUES LOADING POPUP
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Daten werden geladen...</p>
        </div>
      )}

      <div className="content-container">
        {/* Linke Seite (Buttons) */}
        <div className="left-container">
          <div className="button-container">
            <label className="styled-button">
              <i className="icon-single"></i> Einzelne CSV hochladen
              <input
                type="file"
                onChange={(e) => handleSingleCsvUpload(e.target.files[0])}
                accept=".csv"
                className="hidden-input"
              />
            </label>

            <label className="styled-button disabled">
              <i className="icon-multiple"></i> Mehrere CSVs hochladen
              <input
                type="file"
                multiple
                onChange={(e) => handleMultipleCsvUpload(Array.from(e.target.files))}
                accept=".csv"
                className="hidden-input"
                disabled
              />
            </label>
          </div>
        </div>

        {/* Trennlinie */}
        <div className="divider"></div>

        {/* Rechte Seite (Ergebnisse) */}
        <div className="right-container">
          {csvData && (
            <div className="analysis-results">
              <h2>CSV-Analyse</h2>
              <p><strong>Kontonummer:</strong> {csvData.konto || "Keine Kontonummer gefunden"}</p>
              <p><strong>Zeilenanzahl:</strong> {csvData.total_rows}</p>
              <p><strong>Zeitraum:</strong> {csvData.oldest_date || "N/A"} - {csvData.newest_date || "N/A"}</p>
            </div>
          )}

          {multiCsvResults.length > 0 && (
            <div className="multi-analysis-results">
              <h2>Ergebnisse für mehrere Dateien</h2>
              {multiCsvResults.map((result, index) => (
                <div key={index}>
                  <p><strong>Datei {index + 1}:</strong></p>
                  <p>Kontonummer: {result.accountNumber}</p>
                  <p>Zeilenanzahl: {result.totalRows}</p>
                  <p>Zeitraum: {result.oldestDate} - {result.newestDate}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadPage;